import debounce from 'lodash/debounce';
import { createSearchParams } from '@/utils/searchParameters';
import * as api from '@/api';

export default {
    data() {
        return {
            activeSearchTerm: false,
            items: [],
            searchedItems: false,
            paginationData: false,
            activeSorting: false,
        };
    },
    computed: {
        activePage() {
            return this.paginationData ? this.paginationData.current_page : 0;
        },
    },
    methods: {
        prevPageHandler() {
            if(this.$router.history.current.name === 'notification-overview'){
                switch(paginationtype){
                    case 'sentNotifications':
                        this.loadSentNotifications('prev');
                        break;
                    case 'pendingNotifications':
                    default:
                        this.loadPendingNotifications('prev');
                        break;
                }
            } else if (this.activeSearchTerm) {
                this.searchItems(this.activeSearchTerm, this.activePage - 1);
            } else {
                this.loadItems(this.activePage - 1);
            }
        },
        nextPageHandler() {
            if (this.activeSearchTerm) {
                this.searchItems(this.activeSearchTerm, this.activePage + 1);
            } else {
                this.loadItems(this.activePage + 1);
            }
        },
        searchHandler: debounce(function(e) {
            if (e !== '') {
                this.activeSearchTerm = e;
                this.searchItems(e);
            } else {
                this.activeSearchTerm = false;
                this.searchedItems = false;
                this.loadItems();
            }
        }, 300),
        sortClickHandler(field) {
            if (this.activeSorting[field] === 'asc') {
                this.activeSorting = {};
                this.activeSorting[field] = 'desc';
            } else {
                this.activeSorting = {};
                this.activeSorting[field] = 'asc';
            }
            if (this.activeSearchTerm) {
                this.searchItems(this.activeSearchTerm, this.activePage);
            } else {
                this.loadItems(this.activePage);
            }
        },
        async loadItems(page = 1) {
            try {
                let params = { page: page };
                if (Object.keys(this.activeSorting).length > 0) {
                    const field = Object.keys(this.activeSorting)[0];
                    params.order = `${field}${this.activeSorting[field] === 'asc' ? '' : ' desc'}`;
                }
                if (this.additionalParams) {
                    params = { ...params, ...this.additionalParams };
                }
                let fetchApi = 'all';
                if (this.fetchApi !== undefined) fetchApi = this.fetchApi;

                // sort by name if no filter is set
                if(this.apiType === 'users' && fetchApi === 'all' && Object.keys(params).length < 2){
                    params.order = 'name asc';
                }

                const response = await api[this.apiType][fetchApi](params);
                this.items = this.responseField ? response.data[this.responseField] : response.data;

                this.paginationData = response.data._metadata;
            } catch (error) {
                console.error(error);
            }
        },
        async searchItems(searchTerm, page = 1) {
            const allowedParams = this.searchFields;
            const searchParams = createSearchParams(searchTerm, allowedParams, this.searchFields[0]);
            try {
                let params = {
                    ...searchParams,
                    page: page,
                };
                if (this.additionalParams) {
                    params = { ...params, ...this.additionalParams };
                }
                if (Object.keys(this.activeSorting).length > 0) {
                    const field = Object.keys(this.activeSorting)[0];
                    params.order = `${field}${this.activeSorting[field] === 'asc' ? '' : ' desc'}`;
                }
                let searchApi = 'all';
                if (this.searchApi !== undefined) {
                    searchApi = this.searchApi;
                }

                // sort by name if no filter is set
                if(this.apiType === 'users' && searchApi === 'search' && Object.keys(params).length === 2){
                    params.order = 'name asc';
                }

                const response = await api[this.apiType][searchApi](params);
                if (response && response.data) {
                    this.searchedItems = this.responseField ? response.data[this.responseField] : response.data;
                    this.paginationData = response.data._metadata;
                }
            } catch (e) {
                console.error(e);
            }
        },
    },
};
